"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _q = _interopRequireDefault(require("q"));

var _I18n = _interopRequireDefault(require("I18n"));

var _History = _interopRequireDefault(require("./util/History"));

var _Favicon = _interopRequireDefault(require("./components/Favicon"));

var _DocumentHead = _interopRequireDefault(require("./components/portals/DocumentHead"));

var _Footer = _interopRequireDefault(require("./components/footer/Footer"));

var _reactRouterDom = require("react-router-dom");

var _routes = _interopRequireDefault(require("./lib/routes"));

var _reactRedux = require("react-redux");

var _configureStore = _interopRequireDefault(require("./util/configureStore"));

var _handlers = require("q/js/handlers");

// Configure the router
//Redux
// Log and alert both Q `.done()` rejections _and_ unhandled errors (via polled interval)
(0, _handlers.logQPromiseIssuesAndSendAlerts)();

var App =
/*#__PURE__*/
function () {
  function App() {
    (0, _classCallCheck2.default)(this, App);
  }

  (0, _createClass2.default)(App, [{
    key: "start",
    // Kicks off the app. This is intentionally not in the constructor.
    value: function start() {
      var _this = this;

      var storeReady = this.startRedux();

      _q.default.Promise.all([_I18n.default.Info, storeReady]).then(function () {
        _this.startRouter();
      }).done();
    }
  }, {
    key: "startRedux",
    value: function startRedux() {
      this.store = (0, _configureStore.default)();
    }
  }, {
    key: "startRouter",
    value: function startRouter() {
      (0, _reactDom.render)(_react.default.createElement(_reactRedux.Provider, {
        store: this.store
      }, _react.default.createElement(_reactRouterDom.Router, {
        history: _History.default
      }, _react.default.createElement(_DocumentHead.default, null, _react.default.createElement(_Favicon.default, null)), _react.default.createElement(_routes.default, null), _react.default.createElement(_Footer.default, null))), document.getElementsByClassName('page')[0]);
    }
  }]);
  return App;
}();

exports.default = App;
new App().start();
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/app.js
// module id = 159
// module chunks = 0